import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getShopWhatsappTokenByCode = (domain: string, code: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop-whatsapp-code-to-token`,
        method: 'POST',
        params: { domain, code },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}

export default getShopWhatsappTokenByCode;